import { createSlice, current } from '@reduxjs/toolkit';
import { fetchCommunityDataWithPagination } from '../CommunityAPI/communityApi';

const fetchCommunityDataWithPaginationSlice = createSlice({
  name: 'fetchCommunityDataWithPagination',
  initialState: {
    data: [],
    loading: false,
    latestRequestId: null,
    lastResolvedRequestId: null,
    error: null,
    page: 1,
    pageSize: 10,
  },
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    updateCommunityManager(state, action) {
      const { community_id, new_manager_id } = action.payload;
      const community = state.data.data.data.find(c => c.id === community_id);
      if (community) {
        community.owned_by = new_manager_id;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommunityDataWithPagination.pending, (state, action) => {
        state.latestRequestId = action.meta.requestId;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityDataWithPagination.fulfilled, (state, action) => {
        if (state.latestRequestId !== action.meta.requestId) return;
        state.loading = false;
        state.lastResolvedRequestId = action.meta.requestId;
        state.data = action.payload;
      })
      .addCase(fetchCommunityDataWithPagination.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export const { setPage, setPageSize, updateCommunityManager } = fetchCommunityDataWithPaginationSlice.actions;
export default fetchCommunityDataWithPaginationSlice.reducer;
